import {
  WSActions,
  WSControl,
  WSElement,
  WSList,
  WSPanel,
  WSText
} from "@wingspanhq/fe-component-library";
import type { planEnrollmentApiSpec } from "@wingspanhq/wingspan-api-types";
import { OnboardingStep } from "../../../Onboarding/types";
import React from "react";
import { useMutationCancelPlanEnrollment } from "../../../../query/benefits";
import { WSErrorMessage } from "../../../../components/WSErrorMessage/WSErrorMessage";
import { ConfirmCancellationInfo } from "./PlanTypes";

type IPlanType = planEnrollmentApiSpec.PlanEnrollment["planType"];

export const StepConfirmCancellation: React.FC<
  OnboardingStep & { planEnrollmentId: string; planType: IPlanType }
> = props => {
  const [agreedToTerms, setAgreedToTerms] = React.useState(false);

  const [cancelPlanEnrollment, cancelPlanEnrollmentMeta] =
    useMutationCancelPlanEnrollment();

  const effectiveDate = new Date();
  effectiveDate.setDate(effectiveDate.getDate() + 30);

  return (
    <WSPanel>
      <WSList gap="2XL">
        <ConfirmCancellationInfo planType={props.planType} />

        <WSControl
          type="checkbox"
          value={agreedToTerms}
          onChange={setAgreedToTerms}
          size="S"
          color="gray700"
          label={
            <WSText.ParagraphSm color="gray600">
              By checking this box, I acknowledge that I’ve reviewed my impact
              assessment and understand the risks of ending my coverage.
            </WSText.ParagraphSm>
          }
        />

        <WSErrorMessage
          error={cancelPlanEnrollmentMeta.error}
          contextKey="Other"
        />

        <WSActions
          alignment="fill"
          buttons={[
            {
              kind: "Tertiary",
              label: "Back",
              onClick: props.onBack,
              type: "button"
            },
            {
              label: "Submit cancellation",
              loading: cancelPlanEnrollmentMeta.isLoading,
              disabled: !agreedToTerms,
              type: "submit",
              onAsyncClick: async () => {
                await cancelPlanEnrollment(props.planEnrollmentId);
              }
            }
          ]}
        />
      </WSList>
    </WSPanel>
  );
};
